function getLabel(key) {

    if(key) {
        switch (key) {
            case 'price_filter':
                return 'Price';
            case 'case_length_value':
                return 'Case Length';
            case 'case_size_value':
                return 'Case Size';
            case 'case_material':
                return 'Case';
            case 'age_attribute':
                return 'Age';
            case 'gender_attribute':
                return 'Gender';
            case 'band_metal':
                return 'Band Metal';
            case 'head_metal':
                return 'Case Metal';
            case 'gender_mfu':
                return 'Gender';
            case 'lug_to_lug_length':
                return 'Lug to lug length';
            default:
                let str = key.replace('_', ' ').split(' ');
                for (let i = 0; i < str.length; i++) {
                    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
                }
                return str.join(' ');
        }
    }
    return key;
}
function getValue(key, value) {
    switch(key) {
        case 'case_size_value':
        case 'case_thickness':
        case 'band_length':
        case 'band_width':
        case 'case_length':
        case 'case_length_value':
            return value + 'mm';
        case 'features':
            return value.join(', ')
        case 'original_box':
        case 'original_papers':
        case 'booklets':
            return value ? 'Yes' : 'No'
        default:
            return value;
    }
}

const slugify = (str) => {
    str = str.replace(/(^\s+)|(\s+$)/g, '');
    str = str.toLowerCase();
    let from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    let to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
    str = str.replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    return str;
}


const uniformUrl = (url, origin='/') => {
    if (url.substr(-1) !== '/') url += '/';
    if(url.indexOf(origin) === 0) return url;
    return origin + url;
}

// export {getLabel, slugify, getValue, uniformUrl}
exports.getLabel = getLabel
exports.slugify = slugify
exports.getValue = getValue
exports.uniformUrl = uniformUrl
